import React__default from 'react';
import styled from '@emotion/styled';
import { CommonStyles } from '../BaseProps/index.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledFlex = styled.div((_a) => {
  var _b = _a, { theme } = _b, props = __objRest(_b, ["theme"]);
  return [
    CommonStyles(__spreadValues({ theme }, props)),
    {
      display: "flex",
      flexDirection: props.direction,
      gap: theme.spacing[props.gap || "s0"],
      columnGap: theme.spacing[props.gapX || props.gap || "s0"],
      rowGap: theme.spacing[props.gapY || props.gap || "s0"],
      justifyContent: buildVariant(props.justify || ""),
      alignItems: buildVariant(props.align || ""),
      flexWrap: props.flexWrap
    }
  ];
});
const buildVariant = (variant) => {
  switch (variant) {
    case "start":
      return "flex-start";
    case "end":
      return "flex-end";
    default:
      return variant;
  }
};
StyledFlex.defaultProps = {
  direction: "row",
  justify: "start",
  align: "baseline",
  flexWrap: "nowrap"
};
const Flex = (props) => /* @__PURE__ */ React__default.createElement(StyledFlex, __spreadValues({}, props));

export { Flex };
